var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { combineReducers } from 'redux';
import { INICIALIZAR, MOSTRAR_RELOJ, OCULTAR_RELOJ, MOVER_RELOJ } from '../actions';
var defaultConfig = {
  textoStart: 'Go',
  textoStop: 'Stop',
  textoReset: 'Reset',
  textoCuentaAlante: 'Count Up',
  textoCuentaAtras: 'Count Down'
};

function config() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultConfig;
  var action = arguments[1];

  switch (action.type) {
    case INICIALIZAR:
      return action.config.configReloj;

    case MOVER_RELOJ:
      return _extends({}, state, {
        x: action.x,
        y: action.y
      });

    default:
      return state;
  }
}

function visible() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case MOSTRAR_RELOJ:
      return true;

    case OCULTAR_RELOJ:
      return false;

    default:
      return state;
  }
}

var reloj = combineReducers({
  config: config,
  visible: visible
});
export default reloj;